import { motion } from "framer-motion";
import { Daisy } from "./Daisy";

export const Loader = () => (
  <motion.div
    data-testid="page-loader"
    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#F7F3EA]"
    initial={{ opacity: 1 }}
    exit={{ opacity: 0, scale: 1.08, filter: "blur(6px)" }}
    transition={{ duration: 0.6, ease: "easeInOut" }}
  >
    <motion.div className="relative flex items-center justify-center" animate={{ rotate: [0, 0, 360] }} transition={{ duration: 2.6, times: [0, 0.45, 1], repeat: Infinity, ease: "easeInOut" }}>
      <motion.span className="absolute rounded-full bg-[#A3AC86]" initial={{ scale: 0 }} animate={{ scale: [0, 1, 1.15, 1] }} transition={{ duration: 0.9 }} style={{ width: 150, height: 150 }} />
      <span className="absolute rounded-full border-2 border-[#A3AC86]/40 animate-ping" style={{ width: 170, height: 170 }} />
      <Daisy size={120} animatePetals className="relative drop-shadow-sm" />
    </motion.div>
    <motion.p className="h-display mt-10 text-3xl" initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.8 }}>
      hravá mateřinka
    </motion.p>
    <motion.p className="font-script text-xl text-[#D96B43] mt-1" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.1 }}>
      Kopretina právě rozkvétá…
    </motion.p>
  </motion.div>
);
